var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompanyIconGradient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2073 39.2185C15.3073 41.3184 17.6473 42.8368 20.2274 43.7735C22.8075 44.7103 25.4153 45.0247 28.0507 44.7169C28.0507 44.7169 31.3292 43.9546 30.9126 41.7032C30.496 39.4519 27.3302 39.2135 27.3302 39.2135C23.3516 39.6499 19.8949 38.4006 16.96 35.4657C14.3793 32.8851 13.0987 29.8139 13.1182 26.2524C13.1376 22.6908 14.4351 19.6223 17.0104 17.0469C19.5858 14.4716 22.6604 13.168 26.2343 13.1363C29.8081 13.1046 32.8854 14.3791 35.466 16.9597C38.1985 19.6922 39.4715 23.0746 39.285 27.1068C39.285 27.1068 39.1951 30.0151 41.7378 30.4007C44.2804 30.7863 44.7517 27.8642 44.7517 27.8642C44.9851 25.2524 44.6337 22.669 43.6973 20.1138C42.761 17.5587 41.2681 15.2564 39.2187 13.207C35.5248 9.51311 31.1309 7.65776 26.0369 7.64097C20.9429 7.62419 16.5932 9.41856 12.9876 13.0241C9.38206 16.6297 7.59382 20.9733 7.62287 26.055C7.65192 31.1367 9.5134 35.5245 13.2073 39.2185Z",
    fill: "url(#paint0_linear_612_1366)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7628 32.5375C20.7387 33.5134 21.8308 34.2143 23.0392 34.6402C24.2477 35.066 25.4727 35.199 26.7143 35.0391C26.7143 35.0391 28.261 34.6616 28.078 33.6049C27.8949 32.5481 26.4069 32.4541 26.4069 32.4541C24.5327 32.6823 22.9137 32.1144 21.5498 30.7505C20.3505 29.5512 19.7657 28.1138 19.7953 26.4381C19.8249 24.7625 20.4528 23.3115 21.6792 22.0851C22.9056 20.8587 24.3595 20.2278 26.041 20.1924C27.7225 20.1569 29.1629 20.7389 30.3622 21.9381C31.632 23.2079 32.2115 24.7919 32.1006 26.6899C32.1006 26.6899 32.0416 28.0586 33.2356 28.2254C34.4296 28.3922 34.668 27.0148 34.668 27.0148C34.7928 25.7848 34.6423 24.5714 34.2165 23.3747C33.7906 22.178 33.1015 21.1035 32.1492 20.1511C30.4326 18.4345 28.3761 17.5869 25.9797 17.6082C23.5833 17.6296 21.5267 18.4987 19.8098 20.2156C18.0928 21.9326 17.2266 23.9863 17.2111 26.3768C17.1956 28.7673 18.0462 30.8209 19.7628 32.5375Z",
    fill: "url(#paint1_linear_612_1366)",
    stroke: "url(#paint2_linear_612_1366)",
    strokeWidth: 1.53999
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_612_1366",
    x1: -4.2566,
    y1: 33.4993,
    x2: 29.7042,
    y2: 42.8368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D6D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C47C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_612_1366",
    x1: 11.5797,
    y1: 29.9472,
    x2: 27.408,
    y2: 34.4771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D6D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C47C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_612_1366",
    x1: 11.5797,
    y1: 29.9472,
    x2: 27.408,
    y2: 34.4771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D6D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C47C6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyIconGradient);
export default __webpack_public_path__ + "static/media/companyIconGradient.922bf3237101ee0861fc95df577b499c.svg";
export { ForwardRef as ReactComponent };